import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 33 32"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M29.532 15.813c0 3.445-.577 6.238-1.29 6.238-.712 0-1.289-2.793-1.289-6.238 0-3.445.577-6.238 1.29-6.238.711 0 1.289 2.793 1.289 6.238Zm-3.291 0c0 3.845-1.641 6.964-3.666 6.964s-3.667-3.119-3.667-6.964S20.55 8.85 22.574 8.85s3.667 3.117 3.667 6.963m-8.044 0c0 4.085-3.283 7.397-7.332 7.397-4.05 0-7.333-3.313-7.333-7.397s3.283-7.396 7.333-7.396c4.05 0 7.332 3.311 7.332 7.396Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }